<template>
  <v-dialog v-model="dialogDettaglioDocumento" fullscreen hide-overlay transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar dark :color="colorModalita" dense>
        <v-btn icon dark @click="closeDialogDocumento">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>{{dialogTitle}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark text @click="closeDialogDocumento">
            Chiudi
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <header-lotto :locLotto="locLotto" :trigger="trigger" @aggiornaLotto="aggiornaLotto" />
      <body-lotto :locLotto="locLotto" :trigger="trigger" @nuovaRiga="onNuovaRiga" @updateTotali="trigger++" @move="spostaRiga" @distinta="onChangeDistinta"/>
      <!-- <footer-lotto :locLotto="locLotto" :trigger="trigger" @updateTotali="triggerLocale++"/> -->
       <v-card-actions>
        <v-row align="center" justify="end">
          <v-btn color="primary" class="mt-3 mr-5" :disabled="saveDisabled" @click="salvaDocumento">Salva lotto</v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { getAnnoRiferimento } from '@/components/helpers.js'
  import documenti from '@/services/documentiService.js'
  import prodotti from '@/services/prodottiService.js'
  import movimenti from '@/services/movimentiService.js'
  import magazzino from '@/services/magazzinoService.js'
  import configurazioni from '@/services/configurazioniService.js'
  import HeaderLotto from './header.vue'
  // import BodyLotto from './bodyAssemblaggio.vue'
  import BodyLotto from './bodyTable.vue'
/*   import FooterLotto from './assemblaggio/footer.vue' */

  export default {
    components: {
      HeaderLotto,
      BodyLotto/* ,
      FooterLotto */
    },
    props: {
      showDialog: { type: Boolean, default: false },
      idDocumento: { type: String, default: '' },
      nuovoDocumento: Boolean,
      readOnly: Boolean,
      filtraTipiDocumento: Array,
      coloreOrdine: Boolean
    },
    data () {
      return {
        locLotto: {model: '', generale: '', source: ''},
        dialogDettaglioDocumento: false,
        trigger: 1,
        triggerLocale: 1,
        daSalvare: false,
        mostraParcheggio: false,
        forzaDocumento: 'lottoAssemblaggio',
        distinta: []
      }
    },
    async mounted() {
      if (this.idDocumento) {
        this.locLotto = await documenti.getDocumento(this.idDocumento)
        this.completaAppoggio()
      } else {
        this.locLotto = await documenti.getModello('lotto')
        this.completaAppoggio()
        this.locLotto.data = new Date()
        const tipi = await configurazioni.getConfigurazione('documenti_parametri', 'tipiDocumento')
        const tipoDocumento = tipi.find(x => x.tipoDocumento === this.forzaDocumento)
        this.locLotto.tipoDocumento = tipoDocumento
        console.log('mounted Assemblaggio')        
      }
      this.dialogDettaglioDocumento = this.showDialog
    },
    watch: {
      async showDialog(value) {
        if (value) {
          await this.refresh()
        }
      },
      trigger() {
        this.daSalvare = true
      }
    },
    computed: {
      dialogTitle() {
        // TODO: Specificare in base al tipo scelto
        return this.idDocumento ? `Documento nr. ${this.idDocumento} ${this.readOnly ? ' (sola lettura)' : ''}` : 'Nuovo lotto di Assemblaggio'
      },
      colorModalita() {
        if (this.coloreOrdine) {
          return this.nuovoDocumento ? 'amber' : 'amber darken-4'
        } else {
          return this.nuovoDocumento ? 'success' : 'primary'
        }
      },
      saveDisabled() {
        if (this.readOnly) return true
        return !this.daSalvare
      }
    },
    methods: {
      onChangeDistinta(value) {
        this.distinta = value
        // console.log('distinta', this.distinta)
      },
      onMostraParcheggio(value) {
        this.mostraParcheggio = value
      },      
      spostaRiga(da, a) {
        let righe = this.locLotto.righe
        let daSpostare = JSON.parse(JSON.stringify(righe[da]))
        righe.splice(da, 1)
        // righe = _.pullAt(righe, da)
        if (a === -1) {
          righe.push(daSpostare)
        } else {
          righe.splice(a, 0, daSpostare)
        }
        this.trigger++
/*         var res = this.locLotto.righe
        debugger */
      },
      async onNuovaRiga(riga) {
        this.locLotto.righe.push(riga)
        // await this.salvaDocumento()
        this.trigger++
      },
      async refresh() {
        this.dialogDettaglioDocumento = true
        if (this.idDocumento) {
          this.locLotto = await documenti.getDocumento(this.idDocumento)
          this.completaAppoggio()
        } else {
          this.locLotto = await documenti.getModello('xxx')
          this.completaAppoggio()
          this.locLotto.data = new Date()
        }
        this.trigger++
      },
      completaAppoggio() {
        let itm = this.locLotto
        _.set(itm,'appoggio.clienteVisibile', itm.tipoDocumento && itm.tipoDocumento.visualizzaCliente)
        _.set(itm,'appoggio.fornitoreVisibile', itm.tipoDocumento && itm.tipoDocumento.visualizzaFornitore)
        _.set(itm,'appoggio.spedizioneVisibile', itm.tipoDocumento && itm.tipoDocumento.infoSpedizione)
        _.set(itm,'appoggio.pagamentoVisibile', itm.tipoDocumento && itm.tipoDocumento.infoPagamento)
        _.set(itm,'appoggio.tipoDocumento', itm.tipoDocumento)
        const clifor = _.get(itm, 'anagrafica.cliente', '') || _.get(itm, 'anagrafica.fornitore', '')
        _.set(itm,'appoggio.clifor', clifor)
      },
      async aggiornaLotto(documento) {
        Object.assign(this.locLotto, documento)
        this.completaAppoggio()
        // await this.salvaDocumento()
        this.trigger++
      },
      async generaXmlItem(itemId) {
        const documento = await documenti.getDocumento(itemId)
        if (documento) {
          const { fattura, nomeFile, xml7File } = await xml7.creaXml7Fattura(documento)
          downloadXml(document, nomeFile, xml7File)
        }
      },
      async salvaDocumento() {
        let itm = this.locLotto
        var result
        if (!itm._id) {
          if (!itm.tipoDocumento) {
            const tipi = await configurazioni.getConfigurazione('documenti_parametri', 'tipiDocumento')
            const tipoDocumento = tipi.find(x => x.tipoDocumento === this.forzaDocumento)
            itm.tipoDocumento = tipoDocumento
          }          
          const numeratore = itm.tipoDocumento.numeratore
          const annoRiferimento = getAnnoRiferimento(itm.data)
          const numero = await configurazioni.getNumeratore(numeratore, true, annoRiferimento)
          itm._id = numero
          itm.codice = numero
          itm.magazzino = itm.magazzino || this.$store.getters['magazzini/codiceMagazzino']
          itm = JSON.parse(JSON.stringify(this.locLotto))
          delete itm.appoggio

          const prodotti_lotto = await this.creaProdottiLotto(itm)
          await prodotti.clearCache()
          // console.log('dopo', itm)
          result = await documenti.creaDocumento(itm)
          // Verifica se va creato il movimento relativo          
          await this.verificaAggiungiMovimenti(result) // TODO: VERIFICARE --> Percorre la distinta e crea tutti i movimenti relativi ai prodotti non di appoggio
        } else {
          itm = JSON.parse(JSON.stringify(this.locLotto))
          delete itm.appoggio
          result = await documenti.aggiornaDocumento(itm)
          // Verifica se va aggiornato il movimento relativo
          await this.verificaModificaMovimenti(result)
        }
        this.locLotto = result
        this.completaAppoggio()
        this.trigger++
        await this.$nextTick()
        this.daSalvare = false
        return result
      },
      closeDialogDocumento() {
        this.dialogDettaglioDocumento = false
        this.$emit('refresh')
      },
      async creaProdottiLotto(lotto) {
        let prog = 0
        for (let p of lotto.righe) {
          prog++
          const base = p.prodotto.codice
          const prodottoBase = await prodotti.getProdotto(base)
          let pr = {...prodottoBase}
          delete pr._rev
          delete pr.valore
          delete pr.appoggio
          delete pr.prodotto
          pr.barcode = []
          pr.descrizione = `${pr.descrizione.trim()}-L.${lotto.codice}.${prog}`
          pr.ultimoAcquisto = {} // completare
          pr.lotti.prodottoBase = false
          pr.lotti.base = base
          pr.lotti.lotto = lotto.codice
          pr.lotti.progressivo = prog
          pr.lotti.produzione = lotto.produzione
          pr.lotti.scadenza = lotto.scadenza
          pr.lotti.distinta = p.distinta
          pr._id = `${base}.${lotto.codice}.${prog}`
          pr.codice = base  // (il codice rimane lo stesso del prodotto base)
          pr.magazzino.giacenza = 0
          pr.magazzino.giacenzaParziale = null
          pr.magazzino.valore = 0
          await prodotti.creaProdotto(pr)
          p.prodotto.codice = pr._id
        }
      },
      async verificaAggiungiMovimenti(documento) {
        // Percorre la distinta e crea tutti i movimenti relativi ai prodotti non di appoggio
        const prodottiDocumento = documento.righe.filter(x => x.prodotto && x.prodotto.codice)
        const modello = await movimenti.getModello('lotto')
        let numErrori = 0
        for (const p of prodottiDocumento) {
          // ********************************************************************
          // Carico Prodotto Assemblato
          // ********************************************************************
            let movimento = JSON.parse(JSON.stringify(modello))
            movimento.data = new Date()
            movimento.magazzino = documento.magazzino
            movimento.prodotto = {
              codice: p.prodotto.codice,
              lotti: [],
              um: p.unitaMisura,
              quantita: +parseFloat(p.quantita).toFixed(2),
              prezzoAcquisto: _.get(p, 'appoggio.prodotto.acquisto', 0),
              prezzoUnitario: _.get(p, 'valore.listino.ivato', true) ? _.get(p, 'valore.prezzoUnitario', 0) : _.get(p, 'valore.prezzoNettoUnitario', 0),
              listino: _.get(p, 'valore.listino', null)
            }
            movimento.quantita = +parseFloat(p.quantita).toFixed(2)
            movimento.valore = p.valore ? +parseFloat(p.valore.importoTotale).toFixed(2) : 0
            movimento.causale = documento.tipoDocumento.causale
            movimento.anagrafica = {
              cliente: _.get(documento, 'anagrafica.cliente', ''),
              fornitore: ''
            }
            movimento.riferimento = {
              tipo: 'documento',
              id: documento.codice,
              data: documento.data
            }
            if (!await magazzino.creaMovimenti(movimento)) {
              numErrori++
            }
          // ********************************************************************
          // Scarico i componenti secondo la distinta base
          // ********************************************************************
          const distinta = p.distinta || []
          for (let el of distinta) {
            if (el.tipo === 'prodotto' && !el.semilavorato) {
              const prodotto = _.get(el, 'lotto.codiceProdotto' ,'') || el.codice
              let movimento = JSON.parse(JSON.stringify(modello))
              movimento.data = new Date()
              movimento.magazzino = documento.magazzino
              movimento.prodotto = {
                codice: prodotto,
                lotti: [],
                um: el.unitaMisura,
                quantita: +parseFloat(el.quantita).toFixed(2)
                // TODO: Calcolare se serve ...

                // prezzoAcquisto: _.get(p, 'appoggio.prodotto.acquisto', 0),
                // prezzoUnitario: _.get(p, 'valore.listino.ivato', true) ? _.get(p, 'valore.prezzoUnitario', 0) : _.get(p, 'valore.prezzoNettoUnitario', 0),
                // listino: _.get(p, 'valore.listino', null)
              }
              movimento.quantita = +parseFloat(el.quantita).toFixed(2)
              // movimento.valore = el.valore ? +parseFloat(el.valore.importoTotale).toFixed(2) : 0
              movimento.causale = documento.tipoDocumento.causale2
              movimento.anagrafica = {
                cliente: _.get(documento, 'anagrafica.cliente', ''),
                fornitore: ''
              }
              movimento.riferimento = {
                tipo: 'documento',
                id: documento.codice,
                data: documento.data,
                note: 'scarico distinta'
              }
              if (!await magazzino.creaMovimenti(movimento)) {
                numErrori++
              }
            }
          }


/*           let movimento = JSON.parse(JSON.stringify(modello))
          movimento.data = new Date()
          movimento.magazzino = documento.magazzino
          movimento.prodotto = {
            codice: p.prodotto.codice,
            lotti: [],
            um: p.unitaMisura,
            quantita: +parseFloat(p.quantita).toFixed(2),
            prezzoAcquisto: _.get(p, 'appoggio.prodotto.acquisto', 0),
            prezzoUnitario: _.get(p, 'valore.listino.ivato', true) ? _.get(p, 'valore.prezzoUnitario', 0) : _.get(p, 'valore.prezzoNettoUnitario', 0),
            listino: _.get(p, 'valore.listino', null)
          }
          movimento.quantita = +parseFloat(p.quantita).toFixed(2)
          movimento.valore = p.valore ? +parseFloat(p.valore.importoTotale).toFixed(2) : 0
          movimento.causale = documento.tipoDocumento.causale
          movimento.anagrafica = {
            cliente: documento.anagrafica.cliente,
            fornitore: ''
          }
          movimento.riferimento = {
            tipo: 'documento',
            id: documento.codice,
            data: documento.data
          }
          if (!await magazzino.creaMovimenti(movimento)) {
            numErrori++
          } */
        }

      },
      async verificaModificaMovimenti(documento) {
        if (!['lottoAssemblaggio'].includes(documento.tipoDocumento.codice)) return
        await movimenti.cancellaPerRiferimento('documento', documento.codice)
        await this.verificaAggiungiMovimenti(documento)
      }
    }
  }
</script>
